import styled from 'styled-components';

export const Counter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.yoga.spacing.small}px;
  min-width: ${({ theme }) => theme.yoga.spacing.small}px;
  background-color: ${({ theme }) => theme.yoga.colors.error};
  border-radius: ${({ theme }) => theme.yoga.radii.regular}px;
  padding: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const CounterNumber = styled.p`
  color: ${({ theme }) => theme.yoga.colors.white};
  font-size: ${({ theme }) => theme.yoga.fontSizes.xxsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;
